import React from 'react'
import './about.css'
import Img from '../assets/profile-pic.png'
const about = () => {
  return (
    <div className='about'>
    <h2>About Me</h2>
    <div className='content'>
      <section className='section-main'>
        <p>
        I'M MATHEUS SANTOS. Sou um incansável buscador de conhecimento, autodidata
        e apaixonado pelo mundo da tecnologia.
        </p>
        <p>
          Comecei minha jornada como desenvolvedor quando terminei meu ensino médio,
           quando encontrei um vídeo de Gustavo guanabara no Youtube ensinando Python.
           Com Python criei vamos programas simples desde calcular o Imc, o antecessor e sucessor de um 
           número, jogo de adivinhar entre outros.
           Ao longo dos últimos anos, cultivei minha paixão por codificação estudando
           programação principalmente voltada para web, construindo site usando javaScript.

        </p>
    </section>
    <img src={Img} className="user-img-about"
    alt="Uma foto de matheus"/>
    <section className='section-tecnologias'>
      <p>Principais tecnologias que eu uso:</p>
      <ul>
        <li> HTML</li>
        <li> CSS</li>
        <li> JAVASCRIPT</li>
        <li> REACT</li>
        <li> NODE</li>
      </ul>
    </section>
    </div>
    
</div>
  )
}

export default about